import { AboutTabValue } from './Pages';

const rootSlug = `/about`;
export const Slugs = Object.freeze({
  [AboutTabValue.ABOUTBAMBEE]: `${rootSlug}`,
  [AboutTabValue.LEADERSHIP]: `${rootSlug}/leadership`,
  [AboutTabValue.INVESTORS]: `${rootSlug}/investors`,
  [AboutTabValue.TEAMS]: `${rootSlug}/teams`,
  [AboutTabValue.CULTURE]: `${rootSlug}/culture`,
  // <--BEEREX-439--> This tab will be created before going to prod. <--BEEREX-439-->
  // [AboutTabValue.BENEFITS]: `${rootSlug}/benefits`,
  [AboutTabValue.HRMANAGERS]: `${rootSlug}/hr-managers`,
  [AboutTabValue.CAREERS]: `${rootSlug}/careers`,
});

export default null;
